export class NumberUtil {
  public static min(...values: any[]): number {
    const sanitizedValues = values?.filter((val) => !isNaN(val) && typeof val == 'number') ?? []

    if (sanitizedValues.length > 0) {
      return Math.min(...sanitizedValues)
    } else {
      return 0
    }
  }

  public static max(...values: any[]): number {
    const sanitizedValues = values?.filter((val) => !isNaN(val) && typeof val == 'number') ?? []

    if (sanitizedValues.length > 0) {
      return Math.max(...sanitizedValues)
    } else {
      return 0
    }
  }

  public static parse(value: unknown, defaultValue: number | null = 0): number | undefined {
    if (typeof value === 'string') {
      const val = Number(value)

      if (isNaN(val)) {
        return defaultValue ?? undefined
      } else {
        return val
      }
    } else if (typeof value === 'number') {
      return value
    } else {
      return defaultValue ?? undefined
    }
  }

  public static parseFloat(value: string | number): number {
    if (typeof value === 'number') {
      return value
    } else {
      return parseFloat(value)
    }
  }
}
